// noinspection SpellCheckingInspection
const arcgisConfig = {
    'loaderOptions': { version: '4.23', css: true},
    'queryTasks':[
        {id:1, url:'https://pifa.oefa.gob.pe/arcgis/rest/services/VIG_MON/SERV_VIGILANCIA_AMBIENTAL_PROD/MapServer/', index:0, fields:'COD_EST,NOMB_ESTACION', search:'OBJECTID', name:'Estación'}, 
    ],
    'servicio-arcgis': {
        servicios: [
            {
                url:'https://pifa.oefa.gob.pe/arcgis/rest/services/APP_MAPAS',
                visible: true,
                titulo: 'Cartografía Base',
                servicio: 'SERV_BASE_MFICAM_PROD',
            },
            {
                url:'https://pifa.oefa.gob.pe/arcgis/rest/services/VIG_MON',
                visible: true,
                titulo: 'Vigilancia Ambiental',
                servicio: 'SERV_VIGILANCIA_AMBIENTAL_PROD',
            },            
        ]
    },
    'srv_consulta': [
        {
            id: '1',
            nombre: 'Resumen',
            url: 'https://pifa.oefa.gob.pe/arcgis/rest/services/VIG_MON/SERV_VIGILANCIA_AMB_PROYECTADA/MapServer/1',
        }
    ],
};

const appConfig = {};

export { arcgisConfig, appConfig };
